import { render, staticRenderFns } from "./DocumentsCountry.vue?vue&type=template&id=48c2289a&lang=pug"
import script from "./DocumentsCountry.vue?vue&type=script&lang=js"
export * from "./DocumentsCountry.vue?vue&type=script&lang=js"
import style0 from "./DocumentsCountry.vue?vue&type=style&index=0&id=48c2289a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports